import React from "react";

import { RovingAccessibleButton } from "../RovingTabIndex";

interface IProps extends React.ComponentProps<typeof RovingAccessibleButton> {
    label?: string;
    active: boolean;
}

// Semantic component for representing a role=menuitemradio
export const MenuItemRadio: React.FC<IProps> = ({ children, label, active, disabled, ...props }) => {
    return (
        <RovingAccessibleButton
            {...props}
            role="menuitemradio"
            aria-checked={active}
            aria-disabled={disabled}
            disabled={disabled}
            aria-label={label}
        >
            {children}
        </RovingAccessibleButton>
    );
};
